import { useRef, useState, useCallback } from "react";

export function useDraggableScroll() {
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeftAtStart, setScrollLeftAtStart] = useState(0);
  const scrollContainerRef = useRef<HTMLDivElement>(null);

  const onMouseDown = useCallback((e: React.MouseEvent<HTMLDivElement>) => {
    setIsDragging(true);
    setStartX(e.pageX);
    setScrollLeftAtStart(scrollContainerRef.current?.scrollLeft ?? 0);
  }, []);

  const onMouseMove = useCallback(
    (e: React.MouseEvent<HTMLDivElement>) => {
      if (!isDragging) return;
      e.preventDefault();
      const currentX = e.pageX;
      const deltaX = currentX - startX;

      const newScrollPosition = scrollLeftAtStart - deltaX;
      scrollContainerRef.current?.scrollTo({
        left: newScrollPosition,
      });
    },
    [isDragging, startX, scrollLeftAtStart]
  );

  const onMouseUpOrLeave = useCallback(() => {
    setIsDragging(false);
  }, []);

  return {
    ref: scrollContainerRef,
    onMouseDown,
    onMouseMove,
    onMouseUpOrLeave,
    isDragging,
  };
}
